export default __webpack_public_path__ + "static/media/volkswogen-car-icon.f1a0c64c.png";